<template>
    <BaseTipsBlock :title="$t('tips_team_panel.title')" :subtitle="$t('tips_team_panel.subtitle')">
        <div class="gap-row-txs">
            <div class="member-card" v-for="(waiter, index) in list" :key="waiter._id">
                <div class="qrw-label-md bold qrw-text-content-base-secondary num">
                    {{ index + 1 }}
                </div>
                <BaseDivider vertical color="border-base-tertiary" />
                <div class="gap-column-xs avatar-col w-100">
                    <div class="avatar-container" @click="startUpload(waiter._id)">
                        <BaseWorkspaceAvatar round :size="72" :imageUrl="waiter.photo" placeholderIcon="user" />
                    </div>

                    <div class="gap-row-1xs">
                        <div class="qrw-label-lg bold qrw-text-content-base-primary">
                            {{ waiter.name }}
                        </div>
                        <div class="qrw-label-md qrw-text-content-base-secondary">
                            {{ waiter.role || $t('tips_team_panel.role_ph') }}
                        </div>
                    </div>
                </div>
                <BaseDivider vertical color="border-base-tertiary" />
                <div class="gap-row-txs link-col">
                    <div class="qrw-label-sm qrw-text-content-base-secondary">
                        {{ $t('tips_team_panel.link') }}
                    </div>
                    <BaseTextInput size="md" v-model="waiter.personal_tips_link"
                        @blur="() => changeWaiter(index, 'personal_tips_link', waiter.personal_tips_link)" class="w-100"
                        placeholder="https://mytipsgiver.com/to/1234567" />
                </div>
                <BaseDivider vertical color="border-base-tertiary" />
                <BaseBetaToggle :value="waiter.personal_tips_enabled"
                    @input="v => changeWaiter(index, 'personal_tips_enabled', v)" />
            </div>
        </div>

        <PresignedFileUploader @uploaded="onImageUpload" ref="uploader" resourceType="team_avatars"
            :sizeLimit="5 * 1024 * 1024" acceptFilter=".jpg,.png,.svg,.webp,.jpeg,.gif" />

    </BaseTipsBlock>
</template>

<style scoped>
.member-card {
    display: flex;
    flex-direction: row;
    column-gap: 16px;
    padding: 16px;
    border: 1px solid var(--qrw-border-base-tertiary);
    border-radius: 12px;
    background-color: var(--qrw-background-base-secondary);
    align-items: center;
}

.avatar-col {
    align-items: center;
}

.link-col {
    width: 100%;
}

.num {
    width: 48px;
    min-width: 48px;
    text-align: center;
}

.avatar-container {
    display: contents;
    cursor: pointer;
}
</style>

<script>
import PresignedFileUploader from '../PresignedFileUploader.vue';
import BaseTipsBlock from './BaseTipsBlock.vue';

import WaitersAPI from '@/api/waiters'

export default {
    components: {
        BaseTipsBlock,
        PresignedFileUploader
    },
    data () {
        return {
            list: [],

            uploadingTarget: null
        }
    },
    methods: {
        onImageUpload (url) {
            this.changeWaiter(
                this.list.findIndex(
                    waiter => waiter._id === this.uploadingTarget
                ),
                'photo',
                url
            );
            this.uploadingTarget = null;
        },
        startUpload (waiterId) {
            this.uploadingTarget = waiterId;
            this.$refs.uploader.showUploadDialog();
        },
        changeWaiter (index, prop, value) {
            this.$set(
                this.list[index],
                prop,
                value
            );

            WaitersAPI.updateWaiter(
                this.list[index]._id,
                this.list[index]
            );
        }
    },
    computed: {
        cafe () {
            return this.$store.state.cafe;
        },
        waiters () {
            return this.$store.state.waiters;
        }
    },
    watch: {
        waiters () {
            this.list = this.waiters.slice();
        }
    },
    mounted () {
        if (this.waiters) this.list = this.waiters.slice();
    }
}
</script>